import { createContext } from 'react';

type ValidationContextType = {
  registerValidation: (fn: () => boolean) => void;
  triggerValidation: () => boolean;
};

export const ValidationContext = createContext<ValidationContextType>({
  registerValidation: () => {},
  triggerValidation: () => true,
});
